module.exports = __webpack_public_path__ + "img/deepseek.4d9f126a.png";